<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          Estadistica de subscripciones Afrus Engine
        </div>
        <v-breadcrumbs
          divider=">"
          :items="breadcrumbItems"
          class="pa-0"
        ></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="mt-12">
      <v-col cols="12">
        <template>
          <v-card>
            <v-card-title>
              Organizaciones
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :loading="loading"
              :headers="organizationsTable.headers"
              :items="organizationsTable.items"
              :search="search"
            >
              <template
                v-if="this.organizationsTable.items.length"
                v-slot:body="{ items }"
              >
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.id"
                    @click="openSubscriptionsDetails(item)"
                    style="cursor: pointer;"
                  >
                    <td>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">
                            <span>
                              {{ item.id }}
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </td>
                    <td>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span>
                              {{ item.name }}
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </td>
                    <td>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span>
                              {{ item.contact_name }}
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </td>
                    <td>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span>
                              {{ item.contact_info }}
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </td>
                    <td>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span>
                              {{ item.phone }}
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <v-navigation-drawer
      :value="isSubscriptionsDetailOpen"
      width="1700px"
      max-width="100vw"
      temporary
      fixed
      right
      color="grey lighten-3"
      style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
    >
      <v-card
        min-height="100vh"
        color="grey lighten-3"
        v-if="isSubscriptionsDetailOpen"
      >
        <BaseToolbar
          title="Subscription Monthly Stats"
          @close="closeSubscriptionDetails"
          :primaryColor="true"
        />
        <v-progress-linear
          v-if="loading"
          indeterminate
          height="5"
          class="my-0"
        />
        <v-card-text
          v-if="!loading"
          style="overflow-y: auto;height: calc(100vh - 64px)"
        >
          <v-container>
            <v-row>
              <v-col cols="3">
                <v-hover>
                  <v-card slot-scope="{ hover }" :raised="hover" outlined>
                    <v-card-title class="d-block">
                      <div class="body-2 font-weight-bold">
                        Subscription Stats -
                        {{ organization ? organization.name : "" }} -
                        {{
                          new Date().toLocaleDateString(undefined, {
                            year: "numeric",
                            month: "long"
                          })
                        }}
                      </div>
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="5" class="subtitle-2 grey--text">
                            Total cobradas:
                          </v-col>
                          <v-col
                            cols="7"
                            class="body-2 grey--text text--darken-4"
                          >
                            {{
                              subscriptionsMonthlyStats
                                ? subscriptionsMonthlyStats.success.length
                                : 0
                            }}
                          </v-col>
                          <v-col cols="5" class="subtitle-2 grey--text">
                            Total pendientes:
                          </v-col>
                          <v-col
                            cols="7"
                            class="body-2 grey--text text--darken-4"
                          >
                            {{
                              subscriptionsMonthlyStats
                                ? subscriptionsMonthlyStats.pending.length
                                : 0
                            }}
                          </v-col>
                          <v-col cols="5" class="subtitle-2 grey--text">
                            Total fallidas:
                          </v-col>
                          <v-col
                            cols="7"
                            class="body-2 grey--text text--darken-4"
                          >
                            {{
                              subscriptionsMonthlyStats
                                ? subscriptionsMonthlyStats.failed.length
                                : 0
                            }}
                          </v-col>
                          <v-col cols="5" class="subtitle-2 grey--text">
                            Caso a revisar:
                          </v-col>
                          <v-col
                            cols="7"
                            class="body-2 grey--text text--darken-4"
                          >
                            {{
                              subscriptionsMonthlyStats
                                ? subscriptionsMonthlyStats.other.length
                                : 0
                            }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="9">
                <v-hover>
                  <v-card slot-scope="{ hover }" :raised="hover" outlined>
                    <v-expansion-panels accordion class="no-shadow">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <b class="body-2 font-weight-bold">Exitosa</b>
                        </v-expansion-panel-header>
                        <v-divider />
                        <v-expansion-panel-content class="pa-0">
                          <v-data-table
                            :loading="loading"
                            :items="successTable.items"
                            :search="successTable.search"
                            :headers="successTable.headers"
                            :footer-props="{
                              'items-per-page-options': [5, 10, 25, 50, 100]
                            }"
                            :custom-filter="tableSearch"
                          >
                            <template v-slot:top>
                              <v-text-field
                                v-model="successTable.search"
                                label="Search"
                                class="mx-4"
                              >
                              </v-text-field>
                            </template>
                            <template v-slot:item="{ item }">
                              <tr class="cursor-pointer text-no-wrap">
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.id }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription
                                              ? item.subscription.id
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription_gateway_code
                                              ? item.subscription_gateway_code
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                        :style="{
                                          color: getStateForColor(item.state),
                                          'font-weight': getStateForFontWeight(
                                            item.state
                                          )
                                        }"
                                        :class="[
                                          getStateForTextColor(item.state)
                                        ]"
                                      >
                                        <span>
                                          {{ getStateByNumber(item.state) }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.created_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.updated_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.state === 2
                                              ? item.subscription
                                                  .next_payment_date
                                              : (item.state === 4
                                                  ? item.next_payment_date
                                                  : "-") | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.lead.email }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-hover>
                <v-hover class="mt-4">
                  <v-card slot-scope="{ hover }" :raised="hover" outlined>
                    <v-expansion-panels accordion class="no-shadow">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <b class="body-2 font-weight-bold">Pendiente</b>
                        </v-expansion-panel-header>
                        <v-divider />
                        <v-expansion-panel-content class="pa-0">
                          <v-data-table
                            :loading="loading"
                            :items="pendingTable.items"
                            :search="pendingTable.search"
                            :headers="pendingTable.headers"
                            :footer-props="{
                              'items-per-page-options': [5, 10, 25, 50, 100]
                            }"
                            :custom-filter="tableSearch"
                          >
                          <template v-slot:top>
                              <v-text-field
                                v-model="pendingTable.search"
                                label="Search"
                                class="mx-4"
                              >
                              </v-text-field>
                            </template>
                            <template v-slot:item="{ item }">
                              <tr class="cursor-pointer text-no-wrap">
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.id }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription
                                              ? item.subscription.id
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription_gateway_code
                                              ? item.subscription_gateway_code
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                        :style="{
                                          color: getStateForColor(item.state),
                                          'font-weight': getStateForFontWeight(
                                            item.state
                                          )
                                        }"
                                        :class="[
                                          getStateForTextColor(item.state)
                                        ]"
                                      >
                                        <span>
                                          {{ getStateByNumber(item.state) }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.created_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.updated_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.state === 2
                                              ? item.subscription
                                                  .next_payment_date
                                              : (item.state === 4
                                                  ? item.next_payment_date
                                                  : "-") | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.lead.email }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.organization.name }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-hover>
                <v-hover class="mt-4">
                  <v-card slot-scope="{ hover }" :raised="hover" outlined>
                    <v-expansion-panels accordion class="no-shadow">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <b class="body-2 font-weight-bold">Failed</b>
                        </v-expansion-panel-header>
                        <v-divider />
                        <v-expansion-panel-content class="pa-0">
                          <v-data-table
                            :loading="loading"
                            :items="failedTable.items"
                            :search="failedTable.search"
                            :headers="failedTable.headers"
                            :footer-props="{
                              'items-per-page-options': [5, 10, 25, 50, 100]
                            }"
                            :custom-filter="tableSearch"
                          >
                          <template v-slot:top>
                              <v-text-field
                                v-model="failedTable.search"
                                label="Search"
                                class="mx-4"
                              >
                              </v-text-field>
                            </template>
                            <template v-slot:item="{ item }">
                              <tr class="cursor-pointer text-no-wrap">
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.id }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription
                                              ? item.subscription.id
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription_gateway_code
                                              ? item.subscription_gateway_code
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                        :style="{
                                          color: getStateForColor(item.state),
                                          'font-weight': getStateForFontWeight(
                                            item.state
                                          )
                                        }"
                                        :class="[
                                          getStateForTextColor(item.state)
                                        ]"
                                      >
                                        <span>
                                          {{ getStateByNumber(item.state) }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.created_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.updated_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.state === 2
                                              ? item.subscription
                                                  .next_payment_date
                                              : (item.state === 4
                                                  ? item.next_payment_date
                                                  : "-") | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.lead.email }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.organization.name }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-hover>
                <v-hover class="mt-4">
                  <v-card slot-scope="{ hover }" :raised="hover" outlined>
                    <v-expansion-panels accordion class="no-shadow">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <b class="body-2 font-weight-bold">Caso a Revisar</b>
                        </v-expansion-panel-header>
                        <v-divider />
                        <v-expansion-panel-content class="pa-0">
                          <v-data-table
                            :loading="loading"
                            :items="otherTable.items"
                            :search="otherTable.search"
                            :headers="otherTable.headers"
                            :footer-props="{
                              'items-per-page-options': [5, 10, 25, 50, 100]
                            }"
                            :custom-filter="tableSearch"
                          >
                          <template v-slot:top>
                              <v-text-field
                                v-model="otherTable.search"
                                label="Search"
                                class="mx-4"
                              >
                              </v-text-field>
                            </template>
                            <template v-slot:item="{ item }">
                              <tr class="cursor-pointer text-no-wrap">
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.id }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription
                                              ? item.subscription.id
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.subscription_gateway_code
                                              ? item.subscription_gateway_code
                                              : "-"
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                        :style="{
                                          color: getStateForColor(item.state),
                                          'font-weight': getStateForFontWeight(
                                            item.state
                                          )
                                        }"
                                        :class="[
                                          getStateForTextColor(item.state)
                                        ]"
                                      >
                                        <span>
                                          {{ getStateByNumber(item.state) }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.created_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.updated_at
                                              | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{
                                            item.state === 2
                                              ? item.subscription
                                                  .next_payment_date
                                              : (item.state === 4
                                                  ? item.next_payment_date
                                                  : "-") | moment("DD/MM/YYYY")
                                          }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.lead.email }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                                <td>
                                  <v-list-item class="px-0">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="font-weight-medium"
                                      >
                                        <span>
                                          {{ item.organization.name }}
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import BaseToolbar from "@/components/BaseToolbar";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import DonationMixin from "@/mixins/donations";

export default {
  name: "afrus-engine-stats",
  mixins: [DonationMixin],
  components: { VueJsonPretty, BaseToolbar },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t("subscriptions_report.breadcrumb"),
          disabled: false
        },
        {
          text: "Estadisticas",
          disabled: true,
          href: ""
        }
      ],
      loading: false,
      search: "",
      organization: null,
      pendingTable: {
        chargesLoading: false,
        items: [],
        total: 0,
        search: null,
        statuses: [
          { name: "success", value: 2 },
          { name: "pending", value: 4 },
          {
            name: "failed",
            value: 5
          }
        ],
        stateFilter: null,
        pagination: {
          sortBy: ["created_at"],
          sortDesc: [false],
          itemsPerPage: 10
        },
        headers: [
          {
            text: "Charge ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription Gateway Code",
            value: "gateway_code",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.state"),
            value: "state",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },

          {
            text: this.$t("subscriptions_report.charges_table.created_at"),
            value: "created_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.updated_at"),
            value: "updated_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.next_payment"),
            value: "next_payment_date",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Lead",
            value: "lead_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.organization"),
            value: "organization_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          }
        ]
      },
      successTable: {
        chargesLoading: false,
        items: [],
        total: 0,
        search: null,
        statuses: [
          { name: "success", value: 2 },
          { name: "pending", value: 4 },
          {
            name: "failed",
            value: 5
          }
        ],
        stateFilter: null,
        pagination: {
          sortBy: ["created_at"],
          sortDesc: [false],
          itemsPerPage: 10
        },
        headers: [
          {
            text: "Charge ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription Gateway Code",
            value: "gateway_code",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.state"),
            value: "state",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },

          {
            text: this.$t("subscriptions_report.charges_table.created_at"),
            value: "created_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.updated_at"),
            value: "updated_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.next_payment"),
            value: "next_payment_date",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Lead",
            value: "email",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          }
        ]
      },
      failedTable: {
        chargesLoading: false,
        items: [],
        total: 0,
        search: null,
        statuses: [
          { name: "success", value: 2 },
          { name: "pending", value: 4 },
          {
            name: "failed",
            value: 5
          }
        ],
        stateFilter: null,
        pagination: {
          sortBy: ["created_at"],
          sortDesc: [false],
          itemsPerPage: 10
        },
        headers: [
          {
            text: "Charge ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription Gateway Code",
            value: "gateway_code",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.state"),
            value: "state",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },

          {
            text: this.$t("subscriptions_report.charges_table.created_at"),
            value: "created_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.updated_at"),
            value: "updated_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.next_payment"),
            value: "next_payment_date",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Lead",
            value: "lead_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.organization"),
            value: "organization_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          }
        ]
      },
      otherTable: {
        chargesLoading: false,
        items: [],
        total: 0,
        search: null,
        statuses: [
          { name: "success", value: 2 },
          { name: "pending", value: 4 },
          {
            name: "failed",
            value: 5
          }
        ],
        stateFilter: null,
        pagination: {
          sortBy: ["created_at"],
          sortDesc: [false],
          itemsPerPage: 10
        },
        headers: [
          {
            text: "Charge ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Subscription Gateway Code",
            value: "gateway_code",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.state"),
            value: "state",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },

          {
            text: this.$t("subscriptions_report.charges_table.created_at"),
            value: "created_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.updated_at"),
            value: "updated_at",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.next_payment"),
            value: "next_payment_date",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: "Lead",
            value: "lead_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("subscriptions_report.charges_table.organization"),
            value: "organization_id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          }
        ]
      },
      organizationsTable: {
        items: [],
        headers: [
          {
            text: "Charge ID",
            value: "id",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: this.$t("organization.table.org_name"),
            value: "name",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: true
          },
          {
            text: this.$t("organization.table.org_contact_name"),
            value: "contact_name",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("organization.table.org_contact_info"),
            value: "contact_info",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          },
          {
            text: this.$t("organization.table.org_phone"),
            value: "phone",
            class: "text-no-wrap blue--text text--darken-4",
            width: "",
            sortable: false
          }
        ]
      }
    };
  },
  async created() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  },
  watch: {},
  computed: {
    ...mapState({
      afrusEngineOrganizations: ({
        afrusEngine: { afrusEngineOrganizations }
      }) => afrusEngineOrganizations,
      totalOrganizations: ({ afrusEngine: { totalOrganizations } }) =>
        totalOrganizations,
      subscriptionsReport: ({ afrusEngine: { subscriptionsReport } }) =>
        subscriptionsReport,
      charges: ({ afrusEngine: { charges } }) => charges
    }),
    ...mapGetters({
      isSubscriptionsDetailOpen: "afrusEngine/isSubscriptionsDetailOpen",
      subscriptionsMonthlyStats: "afrusEngine/subscriptionsMonthlyStats"
    })
  },
  methods: {
    ...mapActions({
      getAfrusEngineOrganizations: "afrusEngine/getAfrusEngineOrganizations",
      openSubscriptionsDetail: "afrusEngine/openSubscriptionsDetail"
    }),
    ...mapMutations({
      toggleDetails: "afrusEngine/toggleDetails"
    }),
    async getData() {
      await this.getAfrusEngineOrganizations();
      this.organizationsTable.items = this.afrusEngineOrganizations;
    },
    async openSubscriptionsDetails(organization) {
      this.loading = true;
      this.organization = organization;
      await this.openSubscriptionsDetail({ organization_id: organization.id });
      this.successTable.items = this.subscriptionsMonthlyStats.success;
      this.pendingTable.items = this.subscriptionsMonthlyStats.pending;
      this.failedTable.items = this.subscriptionsMonthlyStats.failed;
      this.otherTable.items = this.subscriptionsMonthlyStats.other;
      this.loading = false;
    },
    async closeSubscriptionDetails() {
      this.toggleDetails();
    },
    tableSearch(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        item.id.toString().indexOf(search) !== -1 ||
        item.subscription.id.toString().indexOf(search) !== -1 ||
        item.organization.name.toString().indexOf(search) !== -1 ||
        item.lead.email.toString().indexOf(search) !== -1 ||
        item.subscription_gateway_code.toString().indexOf(search) !== -1
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
